
export async function instantiate(imports={}, runInitializer=true) {
    const cachedJsObjects = new WeakMap();
    // ref must be non-null
    function getCachedJsObject(ref, ifNotCached) {
        if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
        const cached = cachedJsObjects.get(ref);
        if (cached !== void 0) return cached;
        cachedJsObjects.set(ref, ifNotCached);
        return ifNotCached;
    }

    const _ref_Li9za2lrby5tanM_ = imports['./skiko.mjs'];
    const _ref_QGpzLWpvZGEvY29yZQ_ = imports['@js-joda/core'];

    const wasmJsTag = WebAssembly.JSTag;
    const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

    const js_code = {
        'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
        'kotlin.wasm.internal.jsThrow' : typeof wasmJsTag !== 'undefined' && wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
        'kotlin.wasm.internal.stringLength' : (x) => x.length,
        'kotlin.wasm.internal.jsExportStringToWasm' : (src, srcOffset, srcLength, dstAddr) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, dstAddr, srcLength);
            let arrayIndex = 0;
            let srcIndex = srcOffset;
            while (arrayIndex < srcLength) {
                mem16.set([src.charCodeAt(srcIndex)], arrayIndex);
                srcIndex++;
                arrayIndex++;
            }     
             },
        'kotlin.wasm.internal.importStringFromWasm' : (address, length, prefix) => { 
            const mem16 = new Uint16Array(wasmExports.memory.buffer, address, length);
            const str = String.fromCharCode.apply(null, mem16);
            return (prefix == null) ? str : prefix + str;
             },
        'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
        'kotlin.wasm.internal.getJsEmptyString' : () => '',
        'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
        'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
        'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
        'kotlin.wasm.internal.externrefHashCode' : 
        (() => {
        const dataView = new DataView(new ArrayBuffer(8));
        function numberHashCode(obj) {
            if ((obj | 0) === obj) {
                return obj | 0;
            } else {
                dataView.setFloat64(0, obj, true);
                return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
            }
        }
        
        const hashCodes = new WeakMap();
        function getObjectHashCode(obj) {
            const res = hashCodes.get(obj);
            if (res === undefined) {
                const POW_2_32 = 4294967296;
                const hash = (Math.random() * POW_2_32) | 0;
                hashCodes.set(obj, hash);
                return hash;
            }
            return res;
        }
        
        function getStringHashCode(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var code  = str.charCodeAt(i);
                hash  = (hash * 31 + code) | 0;
            }
            return hash;
        }
        
        return (obj) => {
            if (obj == null) {
                return 0;
            }
            switch (typeof obj) {
                case "object":
                case "function":
                    return getObjectHashCode(obj);
                case "number":
                    return numberHashCode(obj);
                case "boolean":
                    return obj ? 1231 : 1237;
                default:
                    return getStringHashCode(String(obj)); 
            }
        }
        })(),
        'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
        'kotlin.wasm.internal.intToExternref' : (x) => x,
        'kotlin.wasm.internal.getJsTrue' : () => true,
        'kotlin.wasm.internal.getJsFalse' : () => false,
        'kotlin.wasm.internal.newJsArray' : () => [],
        'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
        'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
        'kotlin.js.jsCatch' : (f) => { 
            let result = null;
            try { 
                f();
            } catch (e) {
               result = e;
            }
            return result;
             },
        'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
        'kotlin.js.jsThrow' : (e) => { throw e; },
        'kotlin.io.printlnImpl' : (message) => console.log(message),
        'kotlin.io.printError' : (error) => console.error(error),
        'kotlin.js.jsArrayGet' : (array, index) => array[index],
        'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
        'kotlin.js.JsArray_$external_fun' : () => new Array(),
        'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
        'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
        'kotlin.js.JsArray_$external_class_get' : () => Array,
        'kotlin.js.stackPlaceHolder_js_code' : () => (''),
        'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
        'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
        'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
        'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
        'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
        'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
        'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
        'kotlin.js.JsString_$external_class_get' : () => JsString,
        'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
        'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
        'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
        'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
        'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
        'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
        'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
        'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
        'kotlin.time.Date_$external_fun' : () => new Date(),
        'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
        'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
        'kotlin.time.dateNow' : () => Date.now(),
        'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
        'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
        'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
        'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
        'kotlinx.coroutines.console_$external_prop_getter' : () => console,
        'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
        'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
        'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
        'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
            const handler = (event) => {
                if (event.source == window && event.data == 'dispatchCoroutine') {
                    event.stopPropagation();
                    process();
                }
            }
            window.addEventListener('message', handler, true);
        },
        'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
        'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
        'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
        'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
        'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
        'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
        'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
        'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
        'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
        'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
        'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
        'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
        'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
        'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
        'org.w3c.dom.css.cssText_$external_prop_setter' : (_this, v) => _this.cssText = v,
        'org.w3c.dom.css.color_$external_prop_setter' : (_this, v) => _this.color = v,
        'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
        'org.w3c.dom.css.display_$external_prop_getter' : (_this) => _this.display,
        'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
        'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
        'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
        'org.w3c.dom.css.lineHeight_$external_prop_setter' : (_this, v) => _this.lineHeight = v,
        'org.w3c.dom.css.padding_$external_prop_setter' : (_this, v) => _this.padding = v,
        'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
        'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
        'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
        'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
        'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
        'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
        'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
        'org.w3c.dom.events.Event_$external_class_get' : () => Event,
        'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
        'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
        'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
        'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
        'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
        'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
        'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
        'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
        'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
        'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
        'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
        'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
        'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
        'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
        'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
        'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
        'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
        'org.w3c.dom.events.MouseEvent_$external_class_instanceof' : (x) => x instanceof MouseEvent,
        'org.w3c.dom.events.MouseEvent_$external_class_get' : () => MouseEvent,
        'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
        'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
        'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
        'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
        'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
        'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
        'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
        'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
        'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
        'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
        'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
        'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
        'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
        'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
        'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
        'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
        'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
        'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
        'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
        'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.dom.head_$external_prop_getter' : (_this) => _this.head,
        'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
        'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.createTextNode_$external_fun' : (_this, p0) => _this.createTextNode(p0),
        'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
        'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
        'org.w3c.dom.querySelectorAll_$external_fun' : (_this, p0) => _this.querySelectorAll(p0),
        'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
        'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
        'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
        'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
        'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
        'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
        'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
        'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
        'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
        'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
        'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
        'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
        'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
        'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
        'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
        'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
        'org.w3c.dom.getElementsByTagName_$external_fun' : (_this, p0) => _this.getElementsByTagName(p0),
        'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
        'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
        'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
        'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
        'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
        'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
        'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
        'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
        'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
        'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
        'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
        'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
        'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
        'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
        'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
        'org.w3c.dom.identifier_$external_prop_getter' : (_this) => _this.identifier,
        'org.w3c.dom.clientX_$external_prop_getter' : (_this) => _this.clientX,
        'org.w3c.dom.clientY_$external_prop_getter' : (_this) => _this.clientY,
        'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
        'org.w3c.dom.right_$external_prop_getter' : (_this) => _this.right,
        'org.w3c.dom.bottom_$external_prop_getter' : (_this) => _this.bottom,
        'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
        'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
        'org.w3c.dom.disabled_$external_prop_getter' : (_this) => _this.disabled,
        'org.w3c.dom.disabled_$external_prop_setter' : (_this, v) => _this.disabled = v,
        'org.w3c.dom.type_$external_prop_getter' : (_this) => _this.type,
        'org.w3c.dom.type_$external_prop_setter' : (_this, v) => _this.type = v,
        'org.w3c.dom.value_$external_prop_getter' : (_this) => _this.value,
        'org.w3c.dom.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'org.w3c.dom.HTMLInputElement_$external_class_instanceof' : (x) => x instanceof HTMLInputElement,
        'org.w3c.dom.HTMLInputElement_$external_class_get' : () => HTMLInputElement,
        'org.w3c.dom.HTMLTitleElement_$external_class_instanceof' : (x) => x instanceof HTMLTitleElement,
        'org.w3c.dom.HTMLTitleElement_$external_class_get' : () => HTMLTitleElement,
        'org.w3c.dom.type_$external_prop_setter_1' : (_this, v) => _this.type = v,
        'org.w3c.dom.HTMLStyleElement_$external_class_instanceof' : (x) => x instanceof HTMLStyleElement,
        'org.w3c.dom.HTMLStyleElement_$external_class_get' : () => HTMLStyleElement,
        'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
        'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
        'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.w3c.dom.targetTouches_$external_prop_getter' : (_this) => _this.targetTouches,
        'org.w3c.dom.changedTouches_$external_prop_getter' : (_this) => _this.changedTouches,
        'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
        'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
        'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
        'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
        'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
        'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
        'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
        'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
        'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
        'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
        'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
        'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
        'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
        'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
        'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
        'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.w3c.xhr.XMLHttpRequest_$external_fun' : () => new XMLHttpRequest(),
        'org.w3c.xhr.status_$external_prop_getter' : (_this) => _this.status,
        'org.w3c.xhr.open_$external_fun' : (_this, p0, p1, p2, p3, p4, isDefault0, isDefault1) => _this.open(p0, p1, p2, isDefault0 ? undefined : p3, isDefault1 ? undefined : p4, ),
        'org.w3c.xhr.send_$external_fun' : (_this, ) => _this.send(),
        'org.w3c.xhr.overrideMimeType_$external_fun' : (_this, p0) => _this.overrideMimeType(p0),
        'kotlinx.browser.window_$external_prop_getter' : () => window,
        'kotlinx.browser.document_$external_prop_getter' : () => document,
        'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
        'org.w3c.dom.item_$external_fun_2' : (_this, p0) => _this.item(p0),
        'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
        'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
        'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util._crypto_js_code' : () => ((globalThis ? globalThis.crypto : (window.crypto || window.msCrypto))),
        'io.ktor.util.getRandomValues_$external_fun' : (_this, p0) => _this.getRandomValues(p0),
        'io.ktor.util.hasNodeApi' : () => 
        (typeof process !== 'undefined' 
            && process.versions != null 
            && process.versions.node != null) ||
        (typeof window !== 'undefined' 
            && typeof window.process !== 'undefined' 
            && window.process.versions != null 
            && window.process.versions.node != null)
        ,
        'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
        'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
        'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
        'io.ktor.util.logging.console_$external_prop_getter' : () => console,
        'io.ktor.util.toJsArrayImpl' : (x) => new Int8Array(x),
        'io.ktor.util.date.Date_$external_fun' : () => new Date(),
        'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
        'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
        'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
        'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
        'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
        'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
        'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
        'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
        'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
        'io.ktor.http.locationOrigin' : () => function() {
            var tmpLocation = null
            if (typeof window !== 'undefined') {
              tmpLocation = window.location
            } else if (typeof self !== 'undefined') {
              tmpLocation = self.location
            }
            var origin = ""
            if (tmpLocation) {
              origin = tmpLocation.origin
            }
            return origin && origin != "null" ? origin : "http://localhost"    
        }(),
        'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
        'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
        'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
        'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
        'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
        'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
        'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
        'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
        'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
        'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
        'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
        'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
        'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
        'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
        'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
        'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
        'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
        'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
        'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
        'io.ktor.client.utils.makeJsObject' : () => { return {}; },
        'io.ktor.client.utils.makeImport' : (name) => import(name),
        'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
        'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
        'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
        'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
        'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
        'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
        'com.daisyos.oralsay.platform.jsSessionGet' : (key) => 
            (function () {
                try {
                    if (typeof sessionStorage === 'undefined') return null;
                    return sessionStorage.getItem(key) || '';
                } catch (e) { return null; }
            })()
            ,
        'com.daisyos.oralsay.platform.jsSessionSet' : (key, value) => 
            (function () {
                if (typeof sessionStorage === 'undefined') return false;
                try { sessionStorage.setItem(key, value); return true; } catch (e) { return false; }
            })()
            ,
        'com.daisyos.oralsay.platform.jsSessionRemove' : (key) => 
            (function () {
                try {
                    if (typeof sessionStorage === 'undefined') return false;
                    sessionStorage.removeItem(key);
                    return true;
                } catch (e) { return false; }
            })()
            ,
        'com.daisyos.oralsay.platform.jsPublishCrashAccountOwner' : (userId) => { { if (typeof window !== 'undefined') window.__oralsayCrashUserId = userId; } },
        'com.daisyos.oralsay.platform.jsInstallWebCrashHandler' : () => { 
                {
                    if (typeof window === 'undefined' || window.__oralsayCrashInstalled) return;
                    window.__oralsayCrashInstalled = true;
        
                    function strHash(s) {
                        var h = 5381, i = s.length;
                        while (i) { h = (h * 33) ^ s.charCodeAt(--i); }
                        return (h >>> 0).toString(36);
                    }
                    function capKeys() {
                        try {
                            var keys = [];
                            for (var i = 0; i < localStorage.length; i++) {
                                var k = localStorage.key(i);
                                if (k && k.indexOf('oralsay_crash_') === 0) keys.push(k);
                            }
                            while (keys.length > 5) { localStorage.removeItem(keys.shift()); }
                        } catch (e) {}
                    }
                    function persist(name, message, stack) {
                        try {
                            if (typeof localStorage === 'undefined') return;
                            var userId = window.__oralsayCrashUserId;
                            if (!userId) return;
                            name = (name || 'Error') + '';
                            message = (message || '') + '';
                            stack = ((stack || '') + '').substring(0, 16000);
                            var firstFrame = (stack.split('\n')[1] || '').trim();
                            var sig = strHash(name + '|' + firstFrame);
                            // Match CrashSignature.localStorageKey: UTF-8 account ID bytes in hex.
                            // The wire signature remains account-independent for server aggregation.
                            var accountHex = Array.from(new TextEncoder().encode(userId)).map(function (b) {
                                return b.toString(16).padStart(2, '0');
                            }).join('');
                            var storageKey = 'u' + accountHex + '-' + sig;
                            var ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
                            var res = (typeof window !== 'undefined' && window.screen)
                                ? (window.screen.width + 'x' + window.screen.height) : '';
                            var report = {
                                crashId: 'web-' + Date.now().toString(36) + '-' + Math.floor(Math.random()*1e6).toString(36),
                                signature: sig,
                                occurredAtMs: Date.now(),
                                appVersion: (window.__oralsayAppVersion || ''),
                                threadName: 'web',
                                exceptionClass: name,
                                message: message,
                                stackTrace: stack,
                                diagnostics: {
                                    appVersion: (window.__oralsayAppVersion || ''),
                                    osName: 'Web', osVersion: ua, deviceModel: 'Browser',
                                    screenMode: 'SINGLE_SCREEN', screenOrientation: '', screenResolution: res,
                                    networkType: '', uiLanguageTag: '', participantSpokenLanguages: [],
                                    platform: 'web'
                                },
                                logTail: '',
                                userKey: userId
                            };
                            capKeys();
                            localStorage.setItem('oralsay_crash_' + storageKey, JSON.stringify(report));
                        } catch (e) {}
                    }
        
                    var prevOnError = window.onerror;
                    window.onerror = function (message, source, lineno, colno, error) {
                        persist(error && error.name, (error && error.message) || message, error && error.stack);
                        if (typeof prevOnError === 'function') { try { return prevOnError.apply(this, arguments); } catch (e) {} }
                        return false;
                    };
                    window.addEventListener('unhandledrejection', function (e) {
                        var r = (e && e.reason) || {};
                        persist(r.name || 'UnhandledRejection', r.message || ('' + r), r.stack);
                    });
                }
                 },
        'com.daisyos.oralsay.platform.jsCrashKeys' : () => 
            {
                if (typeof localStorage === 'undefined') return '';
                var out = [];
                for (var i = 0; i < localStorage.length; i++) {
                    var k = localStorage.key(i);
                    if (k && k.indexOf('oralsay_crash_') === 0) out.push(k.substring(14));
                }
                return out.join(',');
            }
            ,
        'com.daisyos.oralsay.platform.jsCrashGet' : (key) => (typeof localStorage !== 'undefined' && localStorage.getItem(key)) || '',
        'com.daisyos.oralsay.platform.jsCrashRemove' : (key) => { { if (typeof localStorage !== 'undefined') { try { localStorage.removeItem(key); } catch (e) {} } } },
        'com.daisyos.oralsay.platform.jsInstallOnlineBridge' : () => 
            {
                if (typeof window === 'undefined') return;
                if (window.__oralsayNetBridge) return;
                window.__oralsayNetOnline = (typeof navigator !== 'undefined' && navigator.onLine !== false);
                var onOnline = function () { window.__oralsayNetOnline = true; };
                var onOffline = function () { window.__oralsayNetOnline = false; };
                window.addEventListener('online', onOnline);
                window.addEventListener('offline', onOffline);
                window.__oralsayNetBridge = { onOnline: onOnline, onOffline: onOffline };
            }
            ,
        'com.daisyos.oralsay.platform.jsReadOnline' : () => (typeof window === 'undefined') ? true : (window.__oralsayNetOnline !== false),
        'com.daisyos.oralsay.platform.jsOpenPaymentCheckout' : (url) => (function () { try { window.location.assign(url); return true; } catch (e) { return false; } })(),
        'com.daisyos.oralsay.platform.jsOpenEmbeddedPaymentCheckout' : (orderId, clientSecret, publishableKey, minutes, amountFen, returnPath) => 
            (function () {
                var key = 'oralsay:stripe:embedded:v1';
                try {
                    if (typeof sessionStorage === 'undefined') return false;
                    sessionStorage.removeItem(key);
                    sessionStorage.setItem(key, JSON.stringify({schemaVersion: 1, orderId: orderId,
                        clientSecret: clientSecret, publishableKey: publishableKey, minutes: minutes,
                        amountFen: amountFen, returnPath: returnPath, createdAt: Date.now()}));
                    window.location.assign('/pay/');
                    return true;
                } catch (e) {
                    try { sessionStorage.removeItem(key); } catch (ignored) {}
                    return false;
                }
            })()
            ,
        'com.daisyos.oralsay.platform.jsCheckoutPath' : () => window.location.pathname || '/' ,
        'com.daisyos.oralsay.platform.jsIsDebugBuild' : () => (typeof window !== 'undefined' && window.__OralSayDebug === true),
        'com.daisyos.oralsay.platform.jsDateNow' : () => Date.now(),
        'com.daisyos.oralsay.platform.jsNavigatorLanguage' : () => (typeof navigator !== 'undefined' && navigator.language) ? navigator.language : '',
        'com.daisyos.oralsay.platform.jsNavigatorOnline' : () => (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') ? navigator.onLine : true,
        'com.daisyos.oralsay.platform.jsAuthUserAgent' : () => typeof navigator !== 'undefined' ? navigator.userAgent : '',
        'com.daisyos.oralsay.platform.jsOpenExternalAuthUrl' : (url) => 
                (() => {
                    if (typeof window === 'undefined') return false;
                    const width = Math.min(560, window.outerWidth || 560);
                    const height = Math.min(680, window.outerHeight || 680);
                    const left = Math.max(0, (window.screenX || 0) + ((window.outerWidth || width) - width) / 2);
                    const top = Math.max(0, (window.screenY || 0) + ((window.outerHeight || height) - height) / 2);
                    const features = 'popup=yes,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top;
                    const opened = window.open(url, '_blank', features);
                    if (opened === null) return false;
                    try { opened.opener = null; } catch (_) {}
                    return true;
                })()
            ,
        'com.daisyos.oralsay.platform.jsResolvedTimeZone' : () => (typeof Intl !== 'undefined' && Intl.DateTimeFormat) ? (Intl.DateTimeFormat().resolvedOptions().timeZone || '') : '',
        'com.daisyos.oralsay.platform.jsFormatHHmm' : (epochMillis) => new Date(epochMillis).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }),
        'com.daisyos.oralsay.platform.jsFormatHHmmss' : (epochMillis) => new Date(epochMillis).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }),
        'com.daisyos.oralsay.platform.jsOralsayDateLocaleRaw' : () => 
            (function () {
                var locale = (typeof navigator !== 'undefined' && navigator.language) ? navigator.language : 'en-US';
                var parts = [];
                var firstDay = 1;
                try {
                    if (typeof Intl.Locale === 'function') {
                        var li = new Intl.Locale(locale);
                        if (li.weekInfo && typeof li.weekInfo.firstDay === 'number') {
                            firstDay = (li.weekInfo.firstDay === 1) ? 1 : 0;
                        }
                    }
                } catch (e) {}
                parts.push(String(firstDay));
                for (var i = 0; i < 7; i++) {
                    var d = new Date(Date.UTC(2024, 0, 1 + i));
                    parts.push(new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(d));
                }
                for (var m = 0; m < 12; m++) {
                    var d = new Date(Date.UTC(2024, m, 1));
                    parts.push(new Intl.DateTimeFormat(locale, { month: 'long' }).format(d));
                }
                return parts.join('|');
            })()
            ,
        'com.daisyos.oralsay.platform.jsFormatMonthDay' : (epochMillis) => (function(d){ var p=function(n){return n<10?'0'+n:''+n;}; return p(d.getMonth()+1)+'/'+p(d.getDate()); })(new Date(epochMillis)),
        'com.daisyos.oralsay.platform.jsShouldPreferQrLogin' : () => 
            (() => {
                if (typeof window === 'undefined' || typeof screen === 'undefined') return false;
                if (window.__oralsayPreferredLoginMode === 'qr') return true;
                if (window.__oralsayPreferredLoginMode === 'direct') return false;
                const width = Number(window.innerWidth || 0);
                const height = Number(window.innerHeight || 0);
                const screenShortEdge = Math.min(Number(screen.width || width), Number(screen.height || height));
                return width > height && width >= 840 && screenShortEdge >= 600;
            })()
            ,
        'com.daisyos.oralsay.platform.jsLsGet' : (key) => (typeof localStorage !== 'undefined' && localStorage.getItem(key)) || '',
        'com.daisyos.oralsay.platform.jsLsSet' : (key, value) => { 
                {
                    if (typeof window === 'undefined') return;
                    if (typeof localStorage === 'undefined') { window.__oralsayPrefsErr = 'localStorage_unavailable'; return; }
                    try { localStorage.setItem(key, value); }
                    catch (e) {
                        var name = e && e.name ? e.name : 'unknown';
                        window.__oralsayPrefsErr = name;
                    }
                }
                 },
        'com.daisyos.oralsay.platform.jsLsTakeError' : () => 
            {
                if (typeof window === 'undefined') return '';
                var e = window.__oralsayPrefsErr || '';
                window.__oralsayPrefsErr = '';
                return e;
            }
            ,
        'com.daisyos.oralsay.platform.jsLsRemove' : (key) => { 
                {
                    if (typeof window === 'undefined') return;
                    if (typeof localStorage === 'undefined') { window.__oralsayPrefsErr = 'localStorage_unavailable'; return; }
                    try { localStorage.removeItem(key); }
                    catch (e) {
                        var name = e && e.name ? e.name : 'unknown';
                        window.__oralsayPrefsErr = name;
                    }
                }
                 },
        'com.daisyos.oralsay.platform.isReducedMotionEnabled' : () => window.matchMedia('(prefers-reduced-motion: reduce)').matches,
        'com.daisyos.oralsay.platform.jsUserAgent' : () => (typeof navigator !== 'undefined' && navigator.userAgent) ? navigator.userAgent : '',
        'com.daisyos.oralsay.platform.jsScreenResolution' : () => (typeof window !== 'undefined' && window.screen) ? (window.screen.width + 'x' + window.screen.height) : '',
        'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'com.daisyos.oralsay.engine.audio.jsInstallPcmBridge' : () => { 
                if (typeof window === 'undefined' || window.__oralsayPcm) return;
                window.__oralsayPcm = (function () {
                    var ctx = null, stream = null, src = null, proc = null;
                    var chunks = [];
                    var lastError = '';
                    var epoch = 0;
        
                    function start(sampleRate) {
                        if (ctx || stream) return;
                        epoch++;
                        var myEpoch = epoch;
                        chunks = [];
                        lastError = '';
                        if (!navigator || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                            // 浏览器无 getUserMedia 视为"无设备"——常见于非 secure context（http 部署）
                            lastError = 'nodev:getUserMedia_not_supported';
                            return;
                        }
                        navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, channelCount: 1 } })
                            .then(function (s) {
                                if (myEpoch !== epoch) { s.getTracks().forEach(function (t) { t.stop(); }); return; }
                                stream = s;
                                var AudioCtxCtor = window.AudioContext || window.webkitAudioContext;
                                try { ctx = new AudioCtxCtor({ sampleRate: sampleRate }); }
                                catch (e) { ctx = new AudioCtxCtor(); }
                                src = ctx.createMediaStreamSource(s);
                                proc = ctx.createScriptProcessor(4096, 1, 1);
                                proc.onaudioprocess = function (e) {
                                    var input = e.inputBuffer.getChannelData(0);
                                    var ratio = ctx.sampleRate / sampleRate;
                                    var outLen = Math.max(1, Math.floor(input.length / ratio));
                                    var bytes = new Uint8Array(outLen * 2);
                                    var view = new DataView(bytes.buffer);
                                    var maxAbs = 0;
                                    for (var i = 0; i < outLen; i++) {
                                        var srcIdx = i * ratio;
                                        var idx0 = Math.floor(srcIdx);
                                        var idx1 = idx0 + 1 < input.length ? idx0 + 1 : idx0;
                                        var frac = srcIdx - idx0;
                                        var sample = input[idx0] * (1 - frac) + input[idx1] * frac;
                                        if (sample < -1) sample = -1; else if (sample > 1) sample = 1;
                                        var int16 = sample < 0 ? Math.floor(sample * 0x8000) : Math.floor(sample * 0x7FFF);
                                        view.setInt16(i * 2, int16, true);
                                        var absVal = int16 < 0 ? -int16 : int16;
                                        if (absVal > maxAbs) maxAbs = absVal;
                                    }
                                    var bin = '';
                                    var CHUNK = 0x4000;
                                    for (var j = 0; j < bytes.length; j += CHUNK) {
                                        bin += String.fromCharCode.apply(null, bytes.subarray(j, j + CHUNK));
                                    }
                                    chunks.push(btoa(bin));
                                    chunks.push(String(maxAbs | 0));
                                };
                                src.connect(proc);
                                proc.connect(ctx.destination);
                            })
                            .catch(function (err) {
                                if (myEpoch !== epoch) return;
                                // 与 Kotlin 端 classifyJsError 约定的前缀：permission/busy/nodev/(裸字符串)。
                                // 按 W3C MediaDevices spec err.name 是 DOMException 标准枚举，三端 Chrome/Firefox/Safari 一致。
                                var name = err && err.name ? err.name : '';
                                var msg = err && err.message ? err.message : (err ? String(err) : '');
                                var kindPrefix;
                                switch (name) {
                                    case 'NotAllowedError':
                                    case 'SecurityError':
                                        kindPrefix = 'permission:';
                                        break;
                                    case 'NotReadableError':
                                    case 'TrackStartError':
                                        kindPrefix = 'busy:';
                                        break;
                                    case 'NotFoundError':
                                    case 'OverconstrainedError':
                                    case 'ConstraintNotSatisfiedError':
                                        kindPrefix = 'nodev:';
                                        break;
                                    default:
                                        kindPrefix = '';
                                }
                                lastError = kindPrefix + (name || msg || 'unknown');
                            });
                    }
        
                    function stop() {
                        epoch++;
                        try { if (proc) { proc.disconnect(); proc.onaudioprocess = null; } } catch (_) {}
                        try { if (src) src.disconnect(); } catch (_) {}
                        try { if (stream) stream.getTracks().forEach(function (t) { t.stop(); }); } catch (_) {}
                        try { if (ctx) ctx.close(); } catch (_) {}
                        proc = null; src = null; stream = null; ctx = null;
                        chunks = [];
                    }
        
                    function takeError() { var e = lastError; lastError = ''; return e; }
                    function drainBatch() { if (chunks.length === 0) return ''; var s = chunks.join('\n'); chunks = []; return s; }
        
                    return { start: start, stop: stop, takeError: takeError, drainBatch: drainBatch };
                })();
                 },
        'com.daisyos.oralsay.engine.audio.jsPcmStart' : (sampleRate) => { window.__oralsayPcm && window.__oralsayPcm.start(sampleRate) },
        'com.daisyos.oralsay.engine.audio.jsPcmStop' : () => { window.__oralsayPcm && window.__oralsayPcm.stop() },
        'com.daisyos.oralsay.engine.audio.jsPcmTakeError' : () => (window.__oralsayPcm && window.__oralsayPcm.takeError()) || '',
        'com.daisyos.oralsay.engine.audio.jsPcmDrainBatch' : () => (window.__oralsayPcm && window.__oralsayPcm.drainBatch()) || '',
        'com.daisyos.oralsay.engine.tts.jsAudioPlayBase64' : (base64) => 
            {
                try {
                    if (typeof window === 'undefined' || typeof window.URL === 'undefined') {
                        window.__oralsayAudioStatus = 'no_window';
                        return;
                    }
                    if (window.__oralsayAudio) {
                        try { window.__oralsayAudio.pause(); } catch (e) {}
                        if (window.__oralsayAudioUrl) { try { window.URL.revokeObjectURL(window.__oralsayAudioUrl); } catch (e) {} }
                    }
                    window.__oralsayAudioStatus = '';
                    var bin = atob(base64);
                    var len = bin.length;
                    var arr = new Uint8Array(len);
                    for (var i = 0; i < len; i++) { arr[i] = bin.charCodeAt(i); }
                    var blob = new Blob([arr], { type: 'audio/mpeg' });
                    var url = window.URL.createObjectURL(blob);
                    var audio = new Audio(url);
                    audio.addEventListener('ended', function () {
                        try { window.URL.revokeObjectURL(url); } catch (e) {}
                        if (window.__oralsayAudio === audio) { window.__oralsayAudio = null; window.__oralsayAudioUrl = null; }
                        window.__oralsayAudioStatus = 'ended';
                    });
                    audio.addEventListener('error', function () {
                        try { window.URL.revokeObjectURL(url); } catch (e) {}
                        if (window.__oralsayAudio === audio) { window.__oralsayAudio = null; window.__oralsayAudioUrl = null; }
                        window.__oralsayAudioStatus = 'media_error';
                    });
                    window.__oralsayAudio = audio;
                    window.__oralsayAudioUrl = url;
                    var p = audio.play();
                    if (p && typeof p.catch === 'function') {
                        p.catch(function (err) {
                            var name = err && err.name ? err.name : 'unknown';
                            window.__oralsayAudioStatus = 'play_rejected:' + name;
                        });
                    }
                } catch (err) {
                    console.warn('[OralSay] audio play failed', err);
                    window.__oralsayAudioStatus = 'js_exception:' + (err && err.name ? err.name : 'unknown');
                }
            }
            ,
        'com.daisyos.oralsay.engine.tts.jsAudioStop' : () => 
            {
                try {
                    if (typeof window === 'undefined') return;
                    if (window.__oralsayAudio) {
                        try { window.__oralsayAudio.pause(); } catch (e) {}
                        if (window.__oralsayAudioUrl) {
                            try { window.URL.revokeObjectURL(window.__oralsayAudioUrl); } catch (e) {}
                            window.__oralsayAudioUrl = null;
                        }
                        window.__oralsayAudio = null;
                    }
                } catch (e) {}
            }
            ,
        'com.daisyos.oralsay.engine.tts.jsAudioTakeStatus' : () => 
            {
                if (typeof window === 'undefined') return '';
                var s = window.__oralsayAudioStatus || '';
                window.__oralsayAudioStatus = '';
                return s;
            }
            ,
        'com.daisyos.oralsay.engine.tts.jsTtsHasVoiceForLang' : (langBase) => 
            {
                if (typeof window === 'undefined' || !window.speechSynthesis) return false;
                var voices = window.speechSynthesis.getVoices() || [];
                for (var i = 0; i < voices.length; i++) {
                    var l = (voices[i].lang || '').toLowerCase();
                    if (l.indexOf(langBase) === 0) return true;
                }
                return false;
            }
            ,
        'com.daisyos.oralsay.engine.tts.jsTtsSpeak' : (text, lang) => 
            {
                try {
                    if (typeof window === 'undefined' || !window.speechSynthesis || typeof SpeechSynthesisUtterance === 'undefined') {
                        window.__oralsayTtsStatus = 'error:no_api';
                        return;
                    }
                    window.speechSynthesis.cancel();
                    window.__oralsayTtsStatus = '';
                    var u = new SpeechSynthesisUtterance(text);
                    if (lang) u.lang = lang;
                    u.onend = function () { window.__oralsayTtsStatus = 'ended'; };
                    u.onerror = function (e) { window.__oralsayTtsStatus = 'error:' + ((e && e.error) ? e.error : 'unknown'); };
                    window.speechSynthesis.speak(u);
                } catch (err) {
                    window.__oralsayTtsStatus = 'error:' + ((err && err.name) ? err.name : 'unknown');
                }
            }
            ,
        'com.daisyos.oralsay.engine.tts.jsTtsTakeStatus' : () => 
            {
                if (typeof window === 'undefined') return '';
                var s = window.__oralsayTtsStatus || '';
                window.__oralsayTtsStatus = '';
                return s;
            }
            ,
        'com.daisyos.oralsay.engine.tts.jsTtsCancel' : () => 
            {
                if (typeof window !== 'undefined' && window.speechSynthesis) {
                    window.speechSynthesis.cancel();
                }
            }
            ,
        'org.jetbrains.skiko.w3c.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.skiko.w3c.clipboard_$external_prop_getter' : (_this) => _this.clipboard,
        'org.jetbrains.skiko.w3c.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
        'org.jetbrains.skiko.w3c.navigator_$external_prop_getter' : (_this) => _this.navigator,
        'org.jetbrains.skiko.w3c.performance_$external_prop_getter' : (_this) => _this.performance,
        'org.jetbrains.skiko.w3c.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
        'org.jetbrains.skiko.w3c.open_$external_fun' : (_this, p0, p1) => _this.open(p0, p1),
        'org.jetbrains.skiko.w3c.window_$external_object_getInstance' : () => window,
        'org.jetbrains.skiko.w3c.now_$external_fun' : (_this, ) => _this.now(),
        'org.jetbrains.skiko.w3c.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
        'org.jetbrains.skiko.w3c.width_$external_prop_getter' : (_this) => _this.width,
        'org.jetbrains.skiko.w3c.height_$external_prop_getter' : (_this) => _this.height,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
        'org.jetbrains.skiko.w3c.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
        'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
        'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
        'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
        'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_._releaseLocalCallbackScope(),
        'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
        'org.jetbrains.skiko.wasm.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
        'org.jetbrains.skiko.wasm.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
        'org.jetbrains.skiko.wasm.GL_$external_object_getInstance' : () => _ref_Li9za2lrby5tanM_.GL,
        'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
            return {
                alpha: 1,
                depth: 1,
                stencil: 8,
                antialias: 0,
                premultipliedAlpha: 1,
                preserveDrawingBuffer: 0,
                preferLowPowerToHighPerformance: 0,
                failIfMajorPerformanceCaveat: 0,
                enableExtensionsByDefault: 1,
                explicitSwapControl: 0,
                renderViaOffscreenBackBuffer: 0,
                majorVersion: 2,
            }
        }
        ,
        'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
        'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
        'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
        'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
        'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
        'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext,
        'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
        'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
        'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
        'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
        'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
        'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
        'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
        'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
        'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
        'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
        'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
        'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
        'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
        'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
        'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
        'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
        'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
        'androidx.compose.ui.platform.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
        'androidx.compose.ui.platform.InputEvent_$external_class_get' : () => InputEvent,
        'androidx.compose.ui.window.force_$external_prop_getter' : (_this) => _this.force,
        'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
        'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
        'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
        'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
        'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
        'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
        'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
        'org.jetbrains.compose.resources.jsExportInt8ArrayToWasm' :  (src, size, dstAddr) => {
                const mem8 = new Int8Array(wasmExports.memory.buffer, dstAddr, size);
                mem8.set(src);
            }
        ,
        'org.jetbrains.compose.resources.requestResponseAsByteArray' : (req) =>  {
                var text = req.responseText;
                var int8Arr = new Int8Array(text.length);
                for (var i = 0; i < text.length; i++) {
                    int8Arr[i] = text.charCodeAt(i) & 0xFF;
                }
                return int8Arr;
            },
        'org.jetbrains.compose.resources.isInTestEnvironment' : () => window.composeResourcesTesting == true,
        'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
        'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
        'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
        'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
        'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
        'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
        'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
            try {
                body();
                return null;
            } catch(e) {
                return e;
            }
        },
        'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
        'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
        'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
        'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
        'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
        'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
        'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
        'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
        'com.daisyos.oralsay.ui.components.newWechatQrFrameId' : () => 'oralsay-wechat-qr-' + crypto.randomUUID(),
        'com.daisyos.oralsay.ui.components.createWechatQrFrame' : (id, url, state) => 
            (() => {
                const outer = document.createElement('div');
                outer.id = id;
                outer.style.cssText = 'position:fixed;display:none;overflow:hidden;border-radius:14px;background:white;z-index:20;opacity:0;transition:opacity 140ms linear;pointer-events:none;';
                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) outer.style.transition = 'none';
                const frame = document.createElement('iframe');
                frame.credentialless = true;
                frame.setAttribute('sandbox', 'allow-forms allow-scripts allow-same-origin');
                frame.referrerPolicy = 'no-referrer';
                frame.title = 'WeChat website sign-in QR';
                const bridge = new URL(url).hostname !== 'open.weixin.qq.com';
                frame.style.cssText = bridge ? 'position:absolute;left:0;top:0;width:166px;height:166px;border:0;background:white;' : 'position:absolute;left:-66px;top:3px;width:300px;height:400px;border:0;background:white;';
                const callbackOrigin = bridge ? new URL(url).origin : new URL(new URL(url).searchParams.get('redirect_uri')).origin;
                const entry = { outer, frame, bridge, ready:false, code:'', status:'', failed:false, active:true, onMessage:null };
                entry.onMessage = event => {
                    if (event.source !== frame.contentWindow) return;
                    if (event.origin === callbackOrigin && event.data && event.data.type === 'oralsay-wechat-website-code' &&
                        event.data.state === state && /^[A-Za-z0-9_-]{8,2048}$/.test(event.data.code || '')) {
                        entry.code = event.data.code;
                    }
                    if (event.origin === callbackOrigin && event.data && event.data.type === 'oralsay-wechat-website-error' &&
                        event.data.state === state) entry.failed = true;
                    if (bridge && event.origin === callbackOrigin && event.data && event.data.type === 'oralsay-wechat-website-status' &&
                        event.data.state === state && ['ready','scanned','authorizing','expired','cancelled','offline'].includes(event.data.status)) {
                        if (event.data.status === 'ready' || event.data.status === 'scanned') entry.ready = true;
                        entry.status = event.data.status;
                    }
                    if (event.origin === 'https://open.weixin.qq.com') {
                        try {
                            const status = JSON.parse(event.data);
                            if (status.type === 'status' && (status.status === 'wxReady' || status.status === 'wxQRcodeReady')) entry.ready = true;
                        } catch (_) {}
                    }
                };
                frame.onload = () => { if (!bridge) entry.ready = true; };
                window.addEventListener('message', entry.onMessage);
                outer.appendChild(frame);
                document.body.appendChild(outer);
                window.__oralsayWechatQrFrames = window.__oralsayWechatQrFrames || Object.create(null);
                window.__oralsayWechatQrFrames[id] = entry;
                frame.src = url;
            })()
        ,
        'com.daisyos.oralsay.ui.components.removeWechatQrFrame' : (id) => 
            (() => {
                const entries = window.__oralsayWechatQrFrames;
                const entry = entries && entries[id];
                if (!entry) return;
                window.removeEventListener('message', entry.onMessage);
                entry.frame.src = 'about:blank';
                entry.outer.remove();
                delete entries[id];
                if (Object.keys(entries).length === 0) delete window.__oralsayWechatQrFrames;
            })()
        ,
        'com.daisyos.oralsay.ui.components.wechatQrFrameReady' : (id) => !!(window.__oralsayWechatQrFrames && window.__oralsayWechatQrFrames[id] && window.__oralsayWechatQrFrames[id].ready),
        'com.daisyos.oralsay.ui.components.takeWechatQrCode' : (id) => 
            (() => {
                const entry = window.__oralsayWechatQrFrames && window.__oralsayWechatQrFrames[id];
                if (!entry || !entry.code) return '';
                const code = entry.code;
                entry.code = '';
                return code;
            })()
        ,
        'com.daisyos.oralsay.ui.components.takeWechatQrStatus' : (id) => 
            (() => {
                const entry = window.__oralsayWechatQrFrames && window.__oralsayWechatQrFrames[id];
                if (!entry || !entry.status) return '';
                const status = entry.status;
                entry.status = '';
                return status;
            })()
        ,
        'com.daisyos.oralsay.ui.components.wechatQrFrameFailed' : (id) => !!(window.__oralsayWechatQrFrames && window.__oralsayWechatQrFrames[id] && window.__oralsayWechatQrFrames[id].failed),
        'com.daisyos.oralsay.ui.components.setWechatQrFrameActive' : (id, enabled) => 
            (() => {
                const entry = window.__oralsayWechatQrFrames && window.__oralsayWechatQrFrames[id];
                if (!entry) return;
                entry.active = enabled;
                entry.outer.style.opacity = enabled && entry.ready ? '1' : '0';
                entry.outer.inert = !enabled;
            })()
        ,
        'com.daisyos.oralsay.ui.components.moveWechatQrFrame' : (id, x, y, width, height, top, right, bottom, left) => 
            (() => {
                const entry = window.__oralsayWechatQrFrames && window.__oralsayWechatQrFrames[id];
                if (!entry) return;
                const s = entry.outer.style;
                s.left = x + 'px'; s.top = y + 'px'; s.width = width + 'px'; s.height = height + 'px';
                // Keep the same iframe and ticket while fitting its read-only 166px viewport to the card.
                entry.frame.style.transformOrigin = '0 0';
                entry.frame.style.transform = 'scale(' + width / 166 + ',' + height / 166 + ')';
                if (!entry.bridge) {
                    entry.frame.style.left = -66 * width / 166 + 'px';
                    entry.frame.style.top = 3 * height / 166 + 'px';
                }
                s.clipPath = 'inset(' + top + 'px ' + right + 'px ' + bottom + 'px ' + left + 'px)';
                s.display = width > 0 && height > top + bottom && width > left + right ? 'block' : 'none';
            })()
        ,
        'com.daisyos.oralsay.web.readLoginProfileFromQuery' : () => (new URLSearchParams(window.location.search)).get('loginProfile') || '',
        'com.daisyos.oralsay.web.readLocationPath' : () => (window.location && window.location.pathname) ? window.location.pathname : '',
        'com.daisyos.oralsay.web.readLoginProfileFromRuntimeConfig' : () => (typeof window !== 'undefined' && window.__oralsayLoginProfile) ? window.__oralsayLoginProfile : '',
        'com.daisyos.oralsay.web.jsReadBackendQuery' : () => (new URLSearchParams(window.location.search)).get('backend') || '',
        'com.daisyos.oralsay.web.readEmailDeviceCode' : () => (new URLSearchParams(window.location.search)).get('emailDeviceCode') || '',
        'com.daisyos.oralsay.web.readGroupInviteCode' : () => (() => { const p = new URLSearchParams(window.location.search); const c = p.get('code') || ''; return (p.get('group') === 'join' && /^[0-9]{4}$/.test(c)) ? c : ''; })(),
        'com.daisyos.oralsay.web.jsSameOriginUrl' : () => (window.location && window.location.origin) ? window.location.origin : '',
        'com.daisyos.oralsay.web.jsAppLog' : (line) => 
            {
                try {
                    if (window.__oralsayLogPush) window.__oralsayLogPush(line);
                    if (window.__oralsayOrigConsoleLog) window.__oralsayOrigConsoleLog(line);
                } catch (e) {}
            }
            ,
        'com.daisyos.oralsay.web.jsDumpLogRing' : (maxBytes) => 
            (function () {
                try {
                    var ring = window.__oralsayLogRing;
                    if (!ring || !ring.length) return '';
                    var s = ring.join('\n');
                    if (typeof TextEncoder !== 'undefined') {
                        var enc = new TextEncoder().encode(s);
                        if (enc.length > maxBytes) {
                            enc = enc.slice(enc.length - maxBytes);
                            s = new TextDecoder().decode(enc);
                        }
                    } else if (s.length > maxBytes) {
                        s = s.slice(s.length - maxBytes);
                    }
                    return s;
                } catch (e) { return ''; }
            })()
            ,
        'com.daisyos.oralsay.web.jsInstallWebLogCapture' : () => 
            {
                if (typeof window === 'undefined' || window.__oralsayLogCapInstalled) return;
                window.__oralsayLogCapInstalled = true;
                var RING = [];
                var CAP = 3000;
                var MAXLINE = 2000;
                window.__oralsayLogRing = RING;
                function push(line) {
                    try {
                        line = '' + line;
                        if (line.length > MAXLINE) line = line.substring(0, MAXLINE);
                        RING.push(line);
                        if (RING.length > CAP) RING.splice(0, RING.length - CAP);
                    } catch (e) {}
                }
                window.__oralsayLogPush = push;
                window.__oralsayOrigConsoleLog = (console && console.log) ? console.log.bind(console) : function () {};
                function fmt(args) {
                    try {
                        return Array.prototype.map.call(args, function (a) {
                            if (a instanceof Error) return (a.stack || (a.name + ': ' + a.message));
                            if (typeof a === 'object') { try { return JSON.stringify(a); } catch (e) { return String(a); } }
                            return String(a);
                        }).join(' ');
                    } catch (e) { return ''; }
                }
                var levels = ['log', 'info', 'warn', 'error', 'debug'];
                for (var i = 0; i < levels.length; i++) {
                    (function (level) {
                        var orig = (console && console[level]) ? console[level].bind(console) : function () {};
                        console[level] = function () {
                            push('[console.' + level + '] ' + fmt(arguments));
                            orig.apply(null, arguments);
                        };
                    })(levels[i]);
                }
                var prevErr = window.onerror;
                window.onerror = function (message, source, lineno, colno, error) {
                    push('[onerror] ' + ((error && error.stack) || message));
                    if (typeof prevErr === 'function') { try { return prevErr.apply(this, arguments); } catch (e) {} }
                    return false;
                };
                window.addEventListener('unhandledrejection', function (e) {
                    var r = (e && e.reason) || {};
                    push('[unhandledrejection] ' + ((r && r.stack) || r.message || ('' + r)));
                });
            }
            ,
        'com.daisyos.oralsay.web.jsKickFetchWebManifest' : (url) => { 
                {
                    try {
                        if (typeof window === 'undefined' || typeof fetch === 'undefined') return;
                        fetch(url, { cache: 'no-store' })
                            .then(function (r) { return r.ok ? r.text() : ''; })
                            .then(function (t) { window.__oralsayWebManifestJson = t || ''; })
                            .catch(function () { window.__oralsayWebManifestJson = ''; });
                    } catch (e) { /* swallow */ }
                }
                 },
        'com.daisyos.oralsay.web.jsClearManifestBuffer' : () => { 
                {
                    if (typeof window !== 'undefined') {
                        window.__oralsayWebManifestJson = '';
                    }
                }
                 },
        'com.daisyos.oralsay.web.jsReadManifestJson' : () => 
            {
                return (typeof window !== 'undefined' && window.__oralsayWebManifestJson) || '';
            }
            ,
        'com.daisyos.oralsay.web.jsReloadPage' : () => { 
                {
                    if (typeof window !== 'undefined' && window.location) {
                        window.location.reload();
                    }
                }
                 },
        'com.daisyos.oralsay.web.jsNavigateTo' : (url) => { 
                {
                    if (typeof window !== 'undefined' && window.location) {
                        window.location.href = url;
                    }
                }
                 },
        'com.daisyos.oralsay.web.jsOpenWallpaperPicker' : () => 
            {
                try {
                    window.__oralsayWallpaperPick = '';
                    var input = document.createElement('input');
                    input.type = 'file';
                    input.accept = 'image/*';
                    input.onchange = function () {
                        var file = input.files && input.files[0];
                        if (!file) { window.__oralsayWallpaperPick = 'cancel'; return; }
                        var reader = new FileReader();
                        reader.onload = function () {
                            var dataUrl = reader.result || '';
                            var comma = dataUrl.indexOf(',');
                            if (comma < 0) { window.__oralsayWallpaperPick = 'cancel'; return; }
                            var meta = dataUrl.substring(5, comma);
                            var mime = (meta.split(';')[0]) || 'image/*';
                            window.__oralsayWallpaperPick = mime + '\n' + dataUrl.substring(comma + 1);
                        };
                        reader.onerror = function () { window.__oralsayWallpaperPick = 'cancel'; };
                        reader.readAsDataURL(file);
                    };
                    input.click();
                } catch (e) {
                    window.__oralsayWallpaperPick = 'cancel';
                }
            }
            ,
        'com.daisyos.oralsay.web.jsTakeWallpaperPickResult' : () => 
            {
                if (typeof window === 'undefined') return '';
                var s = window.__oralsayWallpaperPick || '';
                if (s) window.__oralsayWallpaperPick = '';
                return s;
            }
        
    }
    
    // Placed here to give access to it from externals (js_code)
    let wasmInstance;
    let require; 
    let wasmExports;

    const isNodeJs = (typeof process !== 'undefined') && (process.release.name === 'node');
    const isDeno = !isNodeJs && (typeof Deno !== 'undefined')
    const isStandaloneJsVM =
        !isDeno && !isNodeJs && (
            typeof d8 !== 'undefined' // V8
            || typeof inIon !== 'undefined' // SpiderMonkey
            || typeof jscOptions !== 'undefined' // JavaScriptCore
        );
    const isBrowser = !isNodeJs && !isDeno && !isStandaloneJsVM && (typeof window !== 'undefined' || typeof self !== 'undefined');
    
    if (!isNodeJs && !isDeno && !isStandaloneJsVM && !isBrowser) {
      throw "Supported JS engine not detected";
    }

    const wasmFilePath = './oralsay-web.wasm';

    const importObject = {
        js_code,
        intrinsics: {
            tag: wasmTag
        },
        './skiko.mjs': imports['./skiko.mjs'],

    };
    
    try {
      if (isNodeJs) {
        const module = await import(/* webpackIgnore: true */'node:module');
        const importMeta = import.meta;
        require = module.default.createRequire(importMeta.url);
        const fs = require('fs');
        const url = require('url');
        const filepath = import.meta.resolve(wasmFilePath);
        const wasmBuffer = fs.readFileSync(url.fileURLToPath(filepath));
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isDeno) {
        const path = await import(/* webpackIgnore: true */'https://deno.land/std/path/mod.ts');
        const binary = Deno.readFileSync(path.fromFileUrl(import.meta.resolve(wasmFilePath)));
        const module = await WebAssembly.compile(binary);
        wasmInstance = await WebAssembly.instantiate(module, importObject);
      }
      
      if (isStandaloneJsVM) {
        const wasmBuffer = read(wasmFilePath, 'binary');
        const wasmModule = new WebAssembly.Module(wasmBuffer);
        wasmInstance = new WebAssembly.Instance(wasmModule, importObject);
      }
      
      if (isBrowser) {
        wasmInstance = (await WebAssembly.instantiateStreaming(fetch(new URL('./oralsay-web.wasm',import.meta.url).href), importObject)).instance;
      }
    } catch (e) {
      if (e instanceof WebAssembly.CompileError) {
        let text = `Please make sure that your runtime environment supports the latest version of Wasm GC and Exception-Handling proposals.
For more information, see https://kotl.in/wasm-help
`;
        if (isBrowser) {
          console.error(text);
        } else {
          const t = "\n" + text;
          if (typeof console !== "undefined" && console.log !== void 0) 
            console.log(t);
          else 
            print(t);
        }
      }
      throw e;
    }
    
    wasmExports = wasmInstance.exports;
    if (runInitializer) {
        wasmExports._initialize();
    }

    return { instance: wasmInstance,  exports: wasmExports };
}
